"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripPercentageWithCommas = exports.stripPercentageWithDotsAndCommas = exports.toPercentageString = void 0;
var Regex_1 = require("./Regex");
var toPercentageString = function (input, precision) {
    if (precision === void 0) { precision = 2; }
    return "".concat(input.toFixed(precision).replace('.', ','), "%");
};
exports.toPercentageString = toPercentageString;
var stripPercentageWithDotsAndCommas = function (percentage) {
    return percentage.replace(Regex_1.RegexConstants.NotPercentage, '');
};
exports.stripPercentageWithDotsAndCommas = stripPercentageWithDotsAndCommas;
var stripPercentageWithCommas = function (percentage) {
    return percentage.replace(Regex_1.RegexConstants.NotPercentageWithCommas, '');
};
exports.stripPercentageWithCommas = stripPercentageWithCommas;
//# sourceMappingURL=Percentage.js.map